(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1286],{

/***/ 4795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_DollarOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/DollarOutlined.js
// This icon file is generated automatically.
var DollarOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z" } }] }, "name": "dollar", "theme": "outlined" };
/* harmony default export */ var asn_DollarOutlined = (DollarOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 5 modules
var AntdIcon = __webpack_require__(89099);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/DollarOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var DollarOutlined_DollarOutlined = function DollarOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_DollarOutlined
  }));
};
DollarOutlined_DollarOutlined.displayName = 'DollarOutlined';
/* harmony default export */ var icons_DollarOutlined = (/*#__PURE__*/react.forwardRef(DollarOutlined_DollarOutlined));

/***/ }),

/***/ 4828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_FundOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/FundOutlined.js
// This icon file is generated automatically.
var FundOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L531 565 416.6 450.5a8.03 8.03 0 00-11.3 0l-214.9 215a8.03 8.03 0 000 11.3l36.7 36.9z" } }] }, "name": "fund", "theme": "outlined" };
/* harmony default export */ var asn_FundOutlined = (FundOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 5 modules
var AntdIcon = __webpack_require__(89099);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/FundOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var FundOutlined_FundOutlined = function FundOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_FundOutlined
  }));
};
FundOutlined_FundOutlined.displayName = 'FundOutlined';
/* harmony default export */ var icons_FundOutlined = (/*#__PURE__*/react.forwardRef(FundOutlined_FundOutlined));

/***/ }),

/***/ 87547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_UserOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/UserOutlined.js
// This icon file is generated automatically.
var UserOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" } }] }, "name": "user", "theme": "outlined" };
/* harmony default export */ var asn_UserOutlined = (UserOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 5 modules
var AntdIcon = __webpack_require__(89099);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/UserOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var UserOutlined_UserOutlined = function UserOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_UserOutlined
  }));
};
UserOutlined_UserOutlined.displayName = 'UserOutlined';
/* harmony default export */ var icons_UserOutlined = (/*#__PURE__*/react.forwardRef(UserOutlined_UserOutlined));

/***/ }),

/***/ 31834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BrokerTradingTools; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/shared/QuickLinks.tsx
var QuickLinks = __webpack_require__(87160);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/shared/TradingTools.tsx



function TradingTools(props) {
  var title = props.title,
      softwares = props.softwares;
  var linkList = [];

  if (softwares) {
    softwares.map(function (software) {
      linkList.push({
        href: '/software/[slug]/',
        as: "/software/".concat(software.attributes.slug),
        linkText: " ".concat(software.attributes.name)
      });
      return linkList;
    });
  }

  return softwares ? /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks/* default */.Z, {
    title: title,
    linkList: linkList
  }) : null;
}
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
;// CONCATENATED MODULE: ./components/broker/BrokerTradingTools.tsx




function BrokerTradingTools(_ref) {
  var _softwares$data;

  var broker = _ref.broker;
  var name = broker.name,
      softwares = broker.softwares;
  var title = '';

  if ((softwares === null || softwares === void 0 ? void 0 : (_softwares$data = softwares.data) === null || _softwares$data === void 0 ? void 0 : _softwares$data.length) > 0) {
    title = "".concat(name, " Trading Tools");
    return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      style: {
        marginBottom: '16px'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 24,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TradingTools, {
          title: title,
          softwares: softwares.data
        })
      })
    });
  }

  return null;
}

/***/ }),

/***/ 63285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CompareBrokerQuickLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87160);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15746);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




function CompareBrokerQuickLinks(_ref) {
  var brokers = _ref.brokers;
  return brokers.map(function (broker, idx) {
    var linkList = [];
    var _broker$attributes = broker.attributes,
        name = _broker$attributes.name,
        slug = _broker$attributes.slug,
        commodityTrading = _broker$attributes.commodity_trading,
        currencyTrading = _broker$attributes.currency_trading;
    linkList.push({
      href: '/broker/[slug]',
      as: "/broker/".concat(slug),
      linkText: " ".concat(name, " Review")
    });

    if (commodityTrading) {
      linkList.push({
        href: '/broker/[slug]/commodity-trading',
        as: "/broker/".concat(slug, "/commodity-trading"),
        linkText: " ".concat(name, " Commodity Trading")
      });
    }

    if (currencyTrading) {
      linkList.push({
        href: '/broker/[slug]/currency-trading',
        as: "/broker/".concat(slug, "/currency-trading"),
        linkText: " ".concat(name, " Currency Trading")
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      style: {
        marginBottom: '16px'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        span: 24,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          title: "".concat(name, " Quick Links"),
          linkList: linkList
        })
      })
    }, idx);
  });
}

/***/ }),

/***/ 63713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AcccountOpeningCharges; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51945);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97565);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var columns = [{
  title: 'Pros',
  dataIndex: 'pros',
  render: function render(text) {
    return text;
  }
}, {
  title: 'Cons',
  dataIndex: 'cons',
  align: 'right'
}];

var TitleComponent = function TitleComponent(name) {
  var Title = antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Title */ .Z.Title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
    level: 2,
    children: "".concat(name, " Pros and Cons")
  });
};

function AcccountOpeningCharges(_ref) {
  var pros = _ref.pros,
      cons = _ref.cons,
      name = _ref.name;
  var data = [];
  var tableLength = pros.length > cons.length ? pros.length : cons.length;

  for (var i = 0; i < tableLength; i += 1) {
    var _pros$i, _pros$i2, _cons$i, _cons$i2;

    data.push({
      key: i,
      pros: ((_pros$i = pros[i]) === null || _pros$i === void 0 ? void 0 : _pros$i.display_text) && ((_pros$i2 = pros[i]) === null || _pros$i2 === void 0 ? void 0 : _pros$i2.display_text),
      cons: ((_cons$i = cons[i]) === null || _cons$i === void 0 ? void 0 : _cons$i.display_text) && ((_cons$i2 = cons[i]) === null || _cons$i2 === void 0 ? void 0 : _cons$i2.display_text)
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    columns: columns,
    dataSource: data,
    bordered: true,
    title: function title() {
      return TitleComponent(name);
    },
    pagination: false
  });
}

/***/ }),

/***/ 87160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuickLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38456);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87547);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88641);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3679);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var titleFormat = function titleFormat(linkTitle, icon) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [icon, " ".concat(linkTitle)]
  });
};

function QuickLinks(props) {
  var icon = props.icon,
      title = props.title,
      linkList = props.linkList,
      country = props.country;
  if (linkList < 1 || linkList === 'undefined') return null;
  return linkList ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [country === 'India' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      style: {
        paddingBottom: '32px'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        style: {
          minWidth: '250px'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
          target: "_blank",
          href: "https://bit.ly/2YUNebF",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            width: 252,
            height: 302,
            alt: "",
            "data-src": "https://assets.fintrakk.com/Zerodha-Banner-252x302.png",
            src: "https://assets.fintrakk.com/Zerodha-Banner-252x302.png"
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z // eslint-disable-next-line prettier/prettier
    , {
      title: titleFormat(title, icon),
      size: "small",
      bordered: false,
      style: {
        // float: 'right',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
        borderRadius: '2px',
        minWidth: '100%',
        marginBottom: '16px'
      },
      headStyle: {
        background: '#E6F7FF',
        padding: '5px 0px 0px 25px'
      },
      bodyStyle: {
        padding: '15px 20px 0px 25px',
        minWidth: '272px'
      },
      children: linkList.map(function (qlink, i) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          style: {
            marginBottom: '1em'
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: qlink.href,
            as: qlink.as,
            children: qlink.linkText
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            style: {
              fontSize: '10px'
            },
            children: qlink.textDescription !== 'null' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
              children: qlink.textDescription
            }) : null
          })]
        }, i);
      })
    })]
  }) : null;
}
QuickLinks.defaultProps = {
  icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
};

/***/ }),

/***/ 20675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ FAQPageJsonLd; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_stripMarkdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22701);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



var FAQPageJsonLd = function FAQPageJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
      articleDataArr = _ref.articleDataArr;
  var jsonld = "{\n    \"@context\": \"https://schema.org\",\n    \"@type\": \"FAQPage\",\n    \"mainEntity\": [\n      ".concat(articleDataArr.map(function (articleData) {
    return "{\n        \"@type\": \"Question\",\n        \"name\": \"".concat(articleData.attributes.title, "\" ,\n        \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": ").concat((0,_utils_stripMarkdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(articleData.attributes.short_description), "\n        }\n    }");
  }), "\n    ]\n  }");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: jsonld
    }
  }, "jsonld-article".concat(keyOverride ? "-".concat(keyOverride) : ''));
};

/***/ }),

/***/ 72240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ BrokerCompare; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(51945);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./components/broker/BrokerTradingTools.tsx + 1 modules
var BrokerTradingTools = __webpack_require__(31834);
// EXTERNAL MODULE: ./components/shared/AddFaq.js
var AddFaq = __webpack_require__(30155);
// EXTERNAL MODULE: ./components/shared/ArticleList.tsx
var ArticleList = __webpack_require__(54242);
// EXTERNAL MODULE: ./components/shared/button/index.tsx
var shared_button = __webpack_require__(61373);
;// CONCATENATED MODULE: ./components/shared/utils/NormalizeSlug.ts
function normalizeSlug(str) {
  var numericsReplaced = str.replace(/^[0-9]/, '');
  return numericsReplaced.split('-').join('_');
}
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
// EXTERNAL MODULE: ./components/shared/ProsAndCons.tsx
var ProsAndCons = __webpack_require__(63713);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 136 modules
var table = __webpack_require__(97565);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/comparebroker/AccountOpeningCharges.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var columns = function columns(_ref) {
  var brokers = _ref.brokers;
  return [{
    title: 'Charge',
    dataIndex: 'charge'
  }].concat(brokers.map(function (broker, idx) {
    return {
      title: broker.attributes.name,
      dataIndex: idx
    };
  }));
};

var keyNameMap = {
  demat_opening_charges: 'Demat Account Opening Charges',
  trading_acc_opening_charges: 'Trading Acc Opening Charges',
  trading_amc: 'Trading Account AMC',
  demat_amc: 'Demat Account AMC'
};

var TitleComp = function TitleComp(_ref2) {
  var brokers = _ref2.brokers;
  var Title = typography/* default.Title */.Z.Title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
    level: 2,
    children: [brokers[0].attributes.name, " vs ", brokers[1].attributes.name, " Account Opening Charges: ", new Date().getFullYear()]
  });
};

function AccountOpeningCharges(_ref3) {
  var brokers = _ref3.brokers;
  var data = Object.keys(keyNameMap).filter(function (k) {
    return k !== '__typename';
  }).map(function (k) {
    return _objectSpread({
      key: k,
      charge: keyNameMap[k] || k
    }, brokers.map(function (broker) {
      var charges = broker.attributes.account_opening_charges;
      if (!charges) return 'N/A';
      return charges[k] || 'N/A';
    }));
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(table/* default */.Z, {
    columns: columns({
      brokers: brokers
    }),
    dataSource: data,
    bordered: true,
    title: function title() {
      return TitleComp({
        brokers: brokers
      });
    },
    pagination: false
  });
}
;// CONCATENATED MODULE: ./components/comparebroker/shared/FOBrokerage.tsx







var FOBrokerage_columns = function columns(foType, brokers) {
  return [{
    title: 'Charge',
    dataIndex: 'charge'
  }, {
    title: "".concat(foType, " Futures (").concat(brokers[0].attributes.name, ")"),
    className: 'column-money',
    dataIndex: 'futures1',
    align: 'right'
  }, {
    title: "".concat(foType, " Options (").concat(brokers[0].attributes.name, ")"),
    className: 'column-money',
    dataIndex: 'options1',
    align: 'right'
  }, {
    title: "".concat(foType, " Futures (").concat(brokers[1].attributes.name, ")"),
    className: 'column-money',
    dataIndex: 'futures2',
    align: 'right'
  }, {
    title: "".concat(foType, " Options (").concat(brokers[1].attributes.name, ")"),
    className: 'column-money',
    dataIndex: 'options2',
    align: 'right'
  }];
};

var renderCommodityLinks = function renderCommodityLinks(brokers) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: brokers.map(function (broker) {
      return broker.attributes.commodity_trading ? /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        style: {
          width: '100%'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
          href: "/broker/[slug]/commodity-trading",
          as: "/broker/".concat(broker.attributes.slug, "/commodity-trading"),
          children: ["Read More about", " ".concat(broker.attributes.name, " "), "Commodity Trading"]
        })
      }) : null;
    })
  });
};

var renderCurrencyLinks = function renderCurrencyLinks(brokers) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: brokers.map(function (broker) {
      return broker.attributes.currency_trading ? /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        style: {
          width: '100%'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
          href: "/broker/[slug]/commodity-trading",
          as: "/broker/".concat(broker.attributes.slug, "/currency-trading"),
          children: ["Read More about", " ".concat(broker.attributes.name, " "), "Currency Trading"]
        })
      }) : null;
    })
  });
};

var FOBrokerage_keyNameMap = {
  brokerage: 'Brokerage',
  stt: 'Securities Transaction Tax (STT)',
  turnover: 'Transaction / Turnover Charges',
  gst: 'Goods and Services Tax (GST)',
  sebi: 'SEBI Charges',
  stamp: 'Stamp Charges'
};
function FOBrokerage(_ref) {
  var brokers = _ref.brokers,
      futuresBrokerage1 = _ref.futuresBrokerage1,
      optionsBrokerage1 = _ref.optionsBrokerage1,
      futuresBrokerage2 = _ref.futuresBrokerage2,
      optionsBrokerage2 = _ref.optionsBrokerage2,
      foType = _ref.foType;
  var data = Object.keys(futuresBrokerage1).filter(function (k) {
    return k !== '__typename';
  }).map(function (k) {
    return {
      key: k,
      charge: FOBrokerage_keyNameMap[k],
      futures1: futuresBrokerage1[k],
      options1: optionsBrokerage1[k],
      futures2: futuresBrokerage2[k],
      options2: optionsBrokerage2[k]
    };
  });

  if (futuresBrokerage1 && optionsBrokerage1 && futuresBrokerage2 && optionsBrokerage2) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(table/* default */.Z, {
        columns: FOBrokerage_columns(foType, brokers),
        dataSource: data,
        bordered: true,
        title: null,
        pagination: false,
        style: {
          marginBottom: '16px'
        }
      }), foType === 'Commodity' ? renderCommodityLinks(brokers) : null, foType === 'Currency' ? renderCurrencyLinks(brokers) : null]
    });
  }

  return null;
}
;// CONCATENATED MODULE: ./components/comparebroker/CommodityFOBrokrage.tsx






function CommodityFOBrokrage(_ref) {
  var _charges$, _charges$2;

  var brokers = _ref.brokers;
  var Title = typography/* default.Title */.Z.Title;
  var charges = brokers.map(function (broker) {
    var consolidatedCharges = broker.attributes.consolidated_charges;
    var flagshipPlan = consolidatedCharges.find(function (charge) {
      return charge.flagship_plan === true;
    });
    return flagshipPlan || consolidatedCharges[0];
  });
  var _brokers$0$attributes = brokers[0].attributes,
      futuresBrokerage1 = _brokers$0$attributes.commodity_futures_brokerage,
      optionsBrokerage1 = _brokers$0$attributes.commodity_options_brokerage;
  var _brokers$1$attributes = brokers[1].attributes,
      futuresBrokerage2 = _brokers$1$attributes.commodity_futures_brokerage,
      optionsBrokerage2 = _brokers$1$attributes.commodity_options_brokerage;
  var textRenderable = ((_charges$ = charges[0]) === null || _charges$ === void 0 ? void 0 : _charges$.commodity) && ((_charges$2 = charges[1]) === null || _charges$2 === void 0 ? void 0 : _charges$2.commodity);
  var tableRenderable = futuresBrokerage1 && optionsBrokerage1 && futuresBrokerage2 && optionsBrokerage2;

  if (!(textRenderable || tableRenderable)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
      style: {
        marginBottom: '16px'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 24,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
          level: 2,
          children: ["".concat(brokers[0].attributes.name, " "), "vs", " ".concat(brokers[1].attributes.name, " "), "Commodity Charges and Plans:", " ".concat(new Date().getFullYear())]
        })
      }), textRenderable ? /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
        span: 24,
        children: ["".concat(brokers[0].attributes.name, " "), "charge", " ".concat(charges[0].commodity, " "), "for commodity and", " ".concat(brokers[1].attributes.name, " "), "charge", " ".concat(charges[1].commodity, " "), "for commodity."]
      }) : null]
    }), tableRenderable ? /*#__PURE__*/(0,jsx_runtime.jsx)(FOBrokerage, {
      brokers: brokers,
      foType: "Commodity",
      futuresBrokerage1: futuresBrokerage1,
      optionsBrokerage1: optionsBrokerage1,
      futuresBrokerage2: futuresBrokerage2,
      optionsBrokerage2: optionsBrokerage2
    }) : null]
  });
} // CommodityFOBrokrage.propTypes = {
//   brokers: PropTypes.arrayOf(
//     PropTypes.shape({
//       name: PropTypes.string.isRequired,
//       commodity_options_brokerage: PropTypes.shape({
//         brokerage: PropTypes.string.isRequired,
//         stt: PropTypes.string.isRequired,
//         turnover: PropTypes.string.isRequired,
//         gst: PropTypes.string.isRequired,
//         sebi: PropTypes.string.isRequired,
//         stamp: PropTypes.string.isRequired,
//       }),
//       // eslint-disable-next-line
//       commodity_futures_brokerage: PropTypes.shape({
//         brokerage: PropTypes.string.isRequired,
//         stt: PropTypes.string.isRequired,
//         turnover: PropTypes.string.isRequired,
//         gst: PropTypes.string.isRequired,
//         sebi: PropTypes.string.isRequired,
//         stamp: PropTypes.string.isRequired,
//       }),
//     })
//   ).isRequired,
// }
// EXTERNAL MODULE: ./components/comparebroker/CompareBrokerQuickLinks.tsx
var CompareBrokerQuickLinks = __webpack_require__(63285);
;// CONCATENATED MODULE: ./components/comparebroker/CompareMoreBrokers.tsx







var CompareMoreBrokers_columns = function columns(broker1, broker2) {
  return [{
    title: broker1.attributes.name,
    dataIndex: 'b1_comparision_link'
  }, {
    title: broker2.attributes.name,
    dataIndex: 'b2_comparision_link'
  }];
};

var generate_vs_link = function generate_vs_link(idx, broker, other_broker) {
  var _broker$attributes = broker.attributes,
      broker_name = _broker$attributes.name,
      broker_slug = _broker$attributes.slug,
      country = _broker$attributes.country;
  var _other_broker$attribu = other_broker.attributes,
      other_name = _other_broker$attribu.name,
      other_slug = _other_broker$attribu.slug,
      otherCountry = _other_broker$attribu.country;
  if (country.name !== otherCountry.name) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: "/comparebroker/[slug]",
    as: broker_slug < other_slug ? "/comparebroker/".concat(broker_slug, "-vs-").concat(other_slug) : "/comparebroker/".concat(other_slug, "-vs-").concat(broker_slug),
    children: "".concat(broker_name, " vs ").concat(other_name)
  }, idx);
};

var dataSource = function dataSource(broker1, broker2, all_brokers) {
  return all_brokers.filter(function (b) {
    var _b$attributes$country, _broker1$attributes$c, _b$attributes$country2, _broker2$attributes$c;

    return b.attributes.slug !== broker1.attributes.slug && b.attributes.slug !== broker2.attributes.slug && ((_b$attributes$country = b.attributes.country) === null || _b$attributes$country === void 0 ? void 0 : _b$attributes$country.name) === ((_broker1$attributes$c = broker1.attributes.country) === null || _broker1$attributes$c === void 0 ? void 0 : _broker1$attributes$c.name) && ((_b$attributes$country2 = b.attributes.country) === null || _b$attributes$country2 === void 0 ? void 0 : _b$attributes$country2.name) === ((_broker2$attributes$c = broker2.attributes.country) === null || _broker2$attributes$c === void 0 ? void 0 : _broker2$attributes$c.name);
  }).map(function (otherBroker, idx) {
    return {
      b1_comparision_link: generate_vs_link(idx, broker1, otherBroker),
      b2_comparision_link: generate_vs_link(idx, broker2, otherBroker)
    };
  });
};

var CompareMoreBrokers_TitleComp = function TitleComp(broker1, broker2) {
  var Title = typography/* default.Title */.Z.Title;
  var b1_name = broker1.attributes.name;
  var b2_name = broker2.attributes.name;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
    level: 2,
    children: ["Other Comparisons of ", b1_name, " and ", b2_name]
  });
};

function CompareMoreBrokers(_ref) {
  var brokers = _ref.brokers,
      all_brokers = _ref.all_brokers;

  var _brokers = (0,slicedToArray/* default */.Z)(brokers, 2),
      broker1 = _brokers[0],
      broker2 = _brokers[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(table/* default */.Z, {
    columns: CompareMoreBrokers_columns(broker1, broker2),
    dataSource: dataSource(broker1, broker2, all_brokers),
    bordered: true,
    title: function title() {
      return CompareMoreBrokers_TitleComp(broker1, broker2);
    },
    pagination: false
  });
}
;// CONCATENATED MODULE: ./components/comparebroker/ConsolidatedCharges.tsx


function ConsolidatedCharges_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ConsolidatedCharges_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ConsolidatedCharges_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ConsolidatedCharges_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ConsolidatedCharges_columns = function columns(_ref) {
  var brokers = _ref.brokers;
  return [{
    title: 'Charge',
    dataIndex: 'charge'
  }].concat(brokers.map(function (broker, idx) {
    return {
      title: broker.attributes.name,
      dataIndex: idx
    };
  }));
};

var ConsolidatedCharges_keyNameMap = {
  plan_name: 'Plan Name',
  equity_delivery: 'Equity Delivery',
  equity_intraday: 'Equity Intraday',
  equity_futures: 'Equity Futures',
  equity_options: 'Equity Options',
  currency_futures: 'Currency Futures',
  currency_options: 'Currency Options',
  commodity: 'Commodity Options',
  mutual_fund: 'Mutual Fund'
};

var TitleComponent = function TitleComponent(broker1Name, broker2Name) {
  var Title = typography/* default.Title */.Z.Title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
    level: 2,
    children: ["".concat(broker1Name, " vs ").concat(broker2Name, " Brokerage Charges and Plans : "), new Date().getFullYear()]
  });
};

function ConsolidatedCharges(_ref2) {
  var brokers = _ref2.brokers;
  var charges = brokers.map(function (broker) {
    var consolidatedCharges = broker.attributes.consolidated_charges;
    var flagshipPlan = consolidatedCharges.find(function (charge) {
      return charge.flagship_plan === true;
    });
    return flagshipPlan || consolidatedCharges[0];
  });
  var data = Object.keys(ConsolidatedCharges_keyNameMap).filter(function (k) {
    return k !== '__typename';
  }).map(function (k) {
    return ConsolidatedCharges_objectSpread({
      key: k,
      charge: ConsolidatedCharges_keyNameMap[k] || k
    }, charges.map(function (charge) {
      if (!charge) return 'N/A';
      return charge[k] || 'N/A';
    }));
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(table/* default */.Z, {
    columns: ConsolidatedCharges_columns({
      brokers: brokers
    }),
    dataSource: data,
    bordered: true,
    title: function title() {
      return TitleComponent(brokers[0].attributes.name, brokers[1].attributes.name);
    },
    pagination: false
  });
}
;// CONCATENATED MODULE: ./components/comparebroker/CurrencyFOBrokrage.tsx






function CurrencyFOBrokrage(_ref) {
  var _charges$, _charges$2, _charges$3, _charges$4;

  var brokers = _ref.brokers;
  var Title = typography/* default.Title */.Z.Title;
  var charges = brokers.map(function (broker) {
    var consolidatedCharges = broker.attributes.consolidated_charges;
    var flagshipPlan = consolidatedCharges.find(function (charge) {
      return charge.flagship_plan === true;
    });
    return flagshipPlan || consolidatedCharges[0];
  });
  var _brokers$0$attributes = brokers[0].attributes,
      futuresBrokerage1 = _brokers$0$attributes.currency_futures_brokerage,
      optionsBrokerage1 = _brokers$0$attributes.currency_options_brokerage;
  var _brokers$1$attributes = brokers[1].attributes,
      futuresBrokerage2 = _brokers$1$attributes.currency_futures_brokerage,
      optionsBrokerage2 = _brokers$1$attributes.currency_options_brokerage;
  var textRenderable = ((_charges$ = charges[0]) === null || _charges$ === void 0 ? void 0 : _charges$.currency_futures) && ((_charges$2 = charges[0]) === null || _charges$2 === void 0 ? void 0 : _charges$2.currency_options) && ((_charges$3 = charges[1]) === null || _charges$3 === void 0 ? void 0 : _charges$3.currency_futures) && ((_charges$4 = charges[1]) === null || _charges$4 === void 0 ? void 0 : _charges$4.currency_options);
  var tableRenderable = futuresBrokerage1 && optionsBrokerage1 && futuresBrokerage2 && optionsBrokerage2;

  if (!(textRenderable || tableRenderable)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
      style: {
        marginBottom: '16px'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 24,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
          level: 2,
          children: ["".concat(brokers[0].attributes.name, " "), "vs", " ".concat(brokers[1].attributes.name, " "), "Currency Charges and Plans:", " ".concat(new Date().getFullYear())]
        })
      }), textRenderable ? /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
        span: 24,
        children: [" ".concat(brokers[0].attributes.name, " "), "charge", " ".concat(charges[0].currency_futures, " "), "for Currency Futures and", " ".concat(charges[0].currency_options, " "), "for Currency Options whereas", " ".concat(brokers[1].attributes.name, " "), "Charges", " ".concat(charges[1].currency_futures, " "), "for Currency futures and", " ".concat(charges[1].currency_options, " "), "for Currency options."]
      }) : null]
    }), tableRenderable ? /*#__PURE__*/(0,jsx_runtime.jsx)(FOBrokerage, {
      brokers: brokers,
      foType: "Currency",
      futuresBrokerage1: futuresBrokerage1,
      optionsBrokerage1: optionsBrokerage1,
      futuresBrokerage2: futuresBrokerage2,
      optionsBrokerage2: optionsBrokerage2
    }) : null]
  });
}
;// CONCATENATED MODULE: ./components/comparebroker/Exposure.tsx


function Exposure_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Exposure_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Exposure_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Exposure_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Exposure_columns = function columns(_ref) {
  var brokers = _ref.brokers;
  return [{
    title: 'Segment',
    dataIndex: 'sgm'
  }].concat(brokers.map(function (broker, idx) {
    return {
      title: broker.attributes.name,
      dataIndex: idx
    };
  }));
};

var Exposure_keyNameMap = {
  equity_delivery: 'Equity Delivery',
  equity_intraday: 'Equity Intraday',
  equity_future: 'Equity Future',
  equity_options: 'Equity Options',
  currency_future: 'Currency Future',
  currency_options: 'Currency Options',
  commodity_future: 'Commodity Future',
  commodity_options: 'Commodity Options'
};

var Exposure_TitleComponent = function TitleComponent(broker1Name, broker2Name) {
  var Title = typography/* default.Title */.Z.Title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
    level: 2,
    children: ["".concat(broker1Name, " vs ").concat(broker2Name, " Margin / Exposure: "), new Date().getFullYear()]
  });
};

function Exposure(_ref2) {
  var brokers = _ref2.brokers;
  var data = Object.keys(Exposure_keyNameMap).filter(function (k) {
    return k !== '__typename';
  }).map(function (k) {
    return Exposure_objectSpread({
      key: k,
      sgm: Exposure_keyNameMap[k] || k
    }, brokers.map(function (broker) {
      var charges = broker.attributes.exposure;
      if (!charges) return 'N/A';
      return charges[k] || 'N/A';
    }));
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(table/* default */.Z, {
    columns: Exposure_columns({
      brokers: brokers
    }),
    dataSource: data,
    bordered: true,
    title: function title() {
      return Exposure_TitleComponent(brokers[0].attributes.name, brokers[1].attributes.name);
    },
    pagination: false
  });
}
// EXTERNAL MODULE: ./components/shared/QuickLinks.tsx
var QuickLinks = __webpack_require__(87160);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/FundOutlined.js + 1 modules
var FundOutlined = __webpack_require__(4828);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DollarOutlined.js + 1 modules
var DollarOutlined = __webpack_require__(4795);
;// CONCATENATED MODULE: ./components/comparebroker/OtherBrokersQL.tsx







function OtherBrokersList(_ref) {
  var allBrokers = _ref.allBrokers,
      currentBrokers = _ref.currentBrokers;
  var fullServiceLinkList = [];
  var discountLinkList = [];
  var brokers = [];
  var country1 = currentBrokers[0].attributes.country.name;
  var country2 = currentBrokers[1].attributes.country.name;
  allBrokers.map(function (broker) {
    var _broker$attributes = broker.attributes,
        name = _broker$attributes.name,
        slug = _broker$attributes.slug;

    if (slug === currentBrokers[0].attributes.slug || slug === currentBrokers[1].attributes.slug) {
      return true;
    }

    if ((country1 !== 'India' || country2 !== 'India') && broker.attributes.country.name !== 'India') {
      brokers.push({
        href: '/broker/[slug]',
        as: "/broker/".concat(slug),
        linkText: " ".concat(name, " Review")
      });
    }

    if (broker.attributes.broker_type === 'full_service') {
      fullServiceLinkList.push({
        href: '/broker/[slug]',
        as: "/broker/".concat(slug),
        linkText: " ".concat(name, " Review")
      });
      return true;
    }

    if (broker.attributes.broker_type === 'discount') {
      discountLinkList.push({
        href: '/broker/[slug]',
        as: "/broker/".concat(slug),
        linkText: " ".concat(name, " Review")
      });
      return true;
    }

    return true;
  });
  if (country1 === 'India' || country2 === 'India') return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      style: {
        marginBottom: '16px'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 24,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks/* default */.Z, {
          title: "Discount Brokers",
          linkList: discountLinkList,
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(FundOutlined/* default */.Z, {})
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      style: {
        marginBottom: '16px'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 24,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks/* default */.Z, {
          title: "Full Service Brokers",
          linkList: fullServiceLinkList,
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(DollarOutlined/* default */.Z, {})
        })
      })
    })]
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
    style: {
      marginBottom: '16px'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      span: 24,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks/* default */.Z, {
        title: "All Brokers",
        linkList: brokers,
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(DollarOutlined/* default */.Z, {})
      })
    })
  });
}
;// CONCATENATED MODULE: ./components/comparebroker/index.tsx
























var header = function header(_ref) {
  var broker1 = _ref.broker1,
      broker2 = _ref.broker2;
  return "".concat(broker1.attributes.name, " vs ").concat(broker2.attributes.name, " Comparison: ").concat(new Date().getFullYear());
};

var ReadMoreLink = function ReadMoreLink(_ref2) {
  var slug = _ref2.slug;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    style: {
      width: '100%',
      textAlign: 'right'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/broker/[slug]",
      as: "/broker/".concat(slug),
      children: "... Read More"
    })
  });
};

function CompareBroker(_ref3) {
  var brokers = _ref3.brokers,
      allBrokers = _ref3.all_brokers,
      articles = _ref3.articles;
  var Title = typography/* default.Title */.Z.Title;

  var _brokers = (0,slicedToArray/* default */.Z)(brokers, 2),
      broker1 = _brokers[0],
      broker2 = _brokers[1];

  var countryId = (0,util/* countryNameToId */.Jr)(broker1.attributes.country.name);
  var pros_cons1 = broker1.attributes.pros_cons;
  var name1 = broker1.attributes.name;
  var pros_cons2 = broker2.attributes.pros_cons;
  var name2 = broker2.attributes.name;

  var _ProsCons = (0,util/* ProsCons */.ci)(pros_cons1),
      pros1 = _ProsCons.pros,
      cons1 = _ProsCons.cons;

  var _ProsCons2 = (0,util/* ProsCons */.ci)(pros_cons2),
      pros2 = _ProsCons2.pros,
      cons2 = _ProsCons2.cons;

  var input = {
    broker: broker1.id,
    country: countryId,
    article_type: 'faq',
    page_url: "".concat(normalizeSlug(broker1.attributes.slug.toLowerCase()), "_vs_").concat(normalizeSlug(broker2.attributes.slug.toLowerCase()))
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
    className: "page-wrapper page",
    gutter: [16, 16],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      className: "title-wrapper",
      children: header({
        broker1: broker1,
        broker2: broker2
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      xs: 24,
      md: 16,
      children: [brokers.map(function (broker, idx) {
        var _broker$attributes = broker.attributes,
            name = _broker$attributes.name,
            details = _broker$attributes.details,
            slug = _broker$attributes.slug;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
              level: 4,
              className: "title-wrapper",
              children: "About ".concat(name)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((react_markdown_default()), {
              children: details.split(' ', 150).join(' ')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReadMoreLink, {
              slug: slug
            })]
          })
        }, idx);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccountOpeningCharges, {
            brokers: brokers
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConsolidatedCharges, {
            brokers: brokers
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Exposure, {
            brokers: brokers
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
            size: "large",
            type: "primary",
            source: "cb-zerodha-account-button",
            children: "Open FREE Equity Investment Account with Zerodha"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyFOBrokrage, {
            brokers: brokers
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CommodityFOBrokrage, {
            brokers: brokers
          })
        })
      }), pros1.length > 0 && cons1.length > 0 && pros2.length > 0 && cons2.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
          className: "row-wrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProsAndCons/* default */.Z, {
            pros: pros1,
            cons: cons1,
            name: name1
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
          className: "row-wrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProsAndCons/* default */.Z, {
            pros: pros2,
            cons: cons2,
            name: name2
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AddFaq/* default */.Z, {
          input: input
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleList/* default */.Z, {
          articles: articles
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CompareMoreBrokers, {
            brokers: brokers,
            all_brokers: allBrokers
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      xs: 24,
      md: 8,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CompareBrokerQuickLinks/* default */.Z, {
        brokers: brokers
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BrokerTradingTools/* default */.Z, {
        broker: broker1.attributes
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BrokerTradingTools/* default */.Z, {
        broker: broker2.attributes
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherBrokersList, {
        allBrokers: allBrokers,
        currentBrokers: brokers
      })]
    })]
  });
}
// EXTERNAL MODULE: ./components/shared/schema/article.tsx
var article = __webpack_require__(28262);
// EXTERNAL MODULE: ./components/shared/schema/FaqSchema.tsx
var FaqSchema = __webpack_require__(20675);
;// CONCATENATED MODULE: ./pages/comparebroker/[slug].tsx












var title = function title(_ref) {
  var broker1 = _ref.broker1,
      broker2 = _ref.broker2;
  return " ".concat(broker1.attributes.name, " vs ").concat(broker2.attributes.name, " Broker Comparison: ").concat(new Date().getFullYear());
};

var description = function description(_ref2) {
  var broker1 = _ref2.broker1,
      broker2 = _ref2.broker2;
  return "Compare ".concat(broker1.attributes.name, " vs ").concat(broker2.attributes.name, " demat, trading, brokerage, charges, margin, plans, exposure");
};

var __N_SSP = true;
function BrokerCompare(props) {
  var router = (0,next_router.useRouter)();
  var asPath = router.asPath;
  var brokerData = props.data;
  var brokers = brokerData.brokers,
      articles = brokerData.articles,
      allBrokers = brokerData.all_brokers,
      navCalculators = brokerData.nav_calculators,
      allPages = brokerData.all_pages;

  var _brokers$data = (0,slicedToArray/* default */.Z)(brokers.data, 2),
      broker1 = _brokers$data[0],
      broker2 = _brokers$data[1];

  var pageTitle = title({
    broker1: broker1,
    broker2: broker2
  });
  var pageDescription = description({
    broker1: broker1,
    broker2: broker2
  });
  var country = {};

  if (broker1.attributes.country.name === 'India') {
    country = {
      attributes: broker1.attributes.country
    };
  } else if (broker2.attributes.country.name === 'India') {
    country = {
      attributes: broker2.attributes.country
    };
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers.data,
    navCalculators: navCalculators.data,
    allPages: allPages.data,
    country: country,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: pageTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: pageDescription
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(article/* ArticleJsonLd */.d, {
      url: (0,util/* pageUri */.TI)(asPath),
      title: pageTitle,
      description: pageDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaqSchema/* FAQPageJsonLd */.M, {
      articleDataArr: articles.data
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompareBroker, {
      brokers: [broker1, broker2],
      all_brokers: allBrokers.data,
      articles: articles.data
    })]
  });
}

/***/ }),

/***/ 6056:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparebroker/[slug]",
      function () {
        return __webpack_require__(72240);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26525:
/***/ (function(module) {

module.exports = function(md, options) {
  options = options || {};
  options.listUnicodeChar = options.hasOwnProperty('listUnicodeChar') ? options.listUnicodeChar : false;
  options.stripListLeaders = options.hasOwnProperty('stripListLeaders') ? options.stripListLeaders : true;
  options.gfm = options.hasOwnProperty('gfm') ? options.gfm : true;
  options.useImgAltText = options.hasOwnProperty('useImgAltText') ? options.useImgAltText : true;

  var output = md || '';

  // Remove horizontal rules (stripListHeaders conflict with this rule, which is why it has been moved to the top)
  output = output.replace(/^(-\s*?|\*\s*?|_\s*?){3,}\s*$/gm, '');

  try {
    if (options.stripListLeaders) {
      if (options.listUnicodeChar)
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, options.listUnicodeChar + ' $1');
      else
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, '$1');
    }
    if (options.gfm) {
      output = output
        // Header
        .replace(/\n={2,}/g, '\n')
        // Fenced codeblocks
        .replace(/~{3}.*\n/g, '')
        // Strikethrough
        .replace(/~~/g, '')
        // Fenced codeblocks
        .replace(/`{3}.*\n/g, '');
    }
    output = output
      // Remove HTML tags
      .replace(/<[^>]*>/g, '')
      // Remove setext-style headers
      .replace(/^[=\-]{2,}\s*$/g, '')
      // Remove footnotes?
      .replace(/\[\^.+?\](\: .*?$)?/g, '')
      .replace(/\s{0,2}\[.*?\]: .*?$/g, '')
      // Remove images
      .replace(/\!\[(.*?)\][\[\(].*?[\]\)]/g, options.useImgAltText ? '$1' : '')
      // Remove inline links
      .replace(/\[(.*?)\][\[\(].*?[\]\)]/g, '$1')
      // Remove blockquotes
      .replace(/^\s{0,3}>\s?/g, '')
      // Remove reference-style links?
      .replace(/^\s{1,2}\[(.*?)\]: (\S+)( ".*?")?\s*$/g, '')
      // Remove atx-style headers
      .replace(/^(\n)?\s{0,}#{1,6}\s+| {0,}(\n)?\s{0,}#{0,} {0,}(\n)?\s{0,}$/gm, '$1$2$3')
      // Remove emphasis (repeat the line to remove double emphasis)
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      // Remove code blocks
      .replace(/(`{3,})(.*?)\1/gm, '$2')
      // Remove inline code
      .replace(/`(.+?)`/g, '$1')
      // Replace two or more newlines with exactly two? Not entirely sure this belongs here...
      .replace(/\n{2,}/g, '\n\n');
  } catch(e) {
    console.error(e);
    return md;
  }
  return output;
};


/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,2682,2769,7527,6873,3679,6568,5045,2841,5239,7565,8182,3492,3337,9774,2888,179], function() { return __webpack_exec__(6056); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);